import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageLoading from "../../../components/loader/PageLoading";
import { _get_interview_list_blog_api } from "../../../DAL/partner/partners";
import { useIds } from "../../../hook/AdminContext";
import { useSnackbar } from "notistack";
import { show_proper_words } from "../../../utils/Constant";
import { CircularProgress } from "@mui/material";
import RecordNotFound from "../../../components/recordNotFound/RecordNotFound";
import { s3baseUri } from "../../../config/config";

export default function FitOutBlogList() {
  const navigate = useNavigate();
  const { setBreadCrumb } = useIds();
  const location = useLocation();
  const { interview_id } = useParams();
  const firstSegment = location.pathname.split("/")[1];
  const { enqueueSnackbar } = useSnackbar();
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [categoryDetail, setCategoryDetail] = useState({});
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const load_more_path = "api/interview_blog/list?page=0&limit=50";

  const fetchCategories = async (path, search, loading, id) => {
    if (!loading) {
      setLoading(true);
      path = load_more_path;
    }
    const response = await _get_interview_list_blog_api(id, search, path);
    if (response.code === 200) {
      setLoadMorePath(response.load_more_url);
      setTotalPages(response.total_pages);
      setCategoryDetail(response.interview_category_detail);
      if (loading) {
        let new_array = categories.concat(response.interview_blog);
        setCategories(new_array);
        setPageNumber((prev) => prev + 1);
      } else {
        setCategories(response.interview_blog);
        setPageNumber(1);
      }
      setLoading(false);
      setIsLoadingMore(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const loadMoreData = () => {
    setIsLoadingMore(true);
    fetchCategories(loadMorePath, searchText, true, interview_id);
  };

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages >= pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, loadMorePath, observer]
  );

  // useEffect(() => {
  //   if (!loading) {
  //     const timeoutId = setTimeout(() => {
  //       fetchCategories(loadMorePath, searchText, false, interview_id);
  //     }, 800);
  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [searchText]);

  useEffect(() => {
    fetchCategories(load_more_path, searchText, false, interview_id);
  }, []);

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
      {
        name: `Interview`,
        path: `/${firstSegment}/interview`,
        active: false,
      },
      {
        name: `Interview Blog`,
        path: "",
        active: true,
      },
    ]);
  }, []);

  const handleDeatilAffilations = (partner) => {
    navigate(
      `/${firstSegment}/interview/interview-blog-list/${interview_id}/interview-detail/${partner?._id}`
    );
  };

  if (loading) {
    return <PageLoading />;
  }

  return (
    <div className="container-fluid ">
      <div className="d-flex mt-3">
        <div className="heading-main  mb-3">
          <h2>{categoryDetail?.title} blogs</h2>
        </div>{" "}
      </div>
      <div className="row g-4">
        {categories && categories.length > 0 ? (
          <>
            {categories.map((item, index) => {
              return (
                <div
                  key={index}
                  className="col-6 col-sm-4 col-md-3 custom-col-5 mt-3 d-flex "
                >
                  <div className="card d-flex flex-column h-100 shadow-sm">
                    <img
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDeatilAffilations(item)}
                      src={s3baseUri + item.image}
                      alt={item?.title}
                      className="card-img-top p-0"
                    />

                    <div className="card-body flex-grow-1 d-flex flex-column card-content-partners">
                      <h5 className="card-title">{item.title}</h5>
                      <p className="card-text">
                        <div
                          className="ck-editor-content"
                          dangerouslySetInnerHTML={{
                            __html: item?.short_description,
                          }}
                        ></div>
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <div className="col-12">
            <RecordNotFound title="Data Not" />
          </div>
        )}
        {totalPages >= pageNumber ? (
          <div className="col-12 text-center mt-3">
            <span
              ref={lastBookElementRef}
              className="mt-3"
              onClick={loadMoreData}
              id="load-more-feed"
            >
              {isLoadingMore ? (
                <CircularProgress color="primary" size="1.5rem" />
              ) : (
                "Load More"
              )}
            </span>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
